import { environment } from '../../environments/environment';

export class GlobalConstants {
  public static apiURL = environment.apiUrl;
}


